exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media print{.no-print,.plainWhiteLogoHeader{display:none}}", ""]);

// exports
